import { store } from "../../../store";
import Transaction from "../../../classes/Transaction";

export default {
  routes: [],

  dialogs: [
    {
      name: "tx-new",
      path: "/tx/new/:type/:forID",
      meta: { auth: () => Transaction.canBeCreatedBy(store.state.main.user) },
      component: () => import("../../../dialogs/employee/TxEdit"),
    },
    {
      name: "tx-edit",
      path: "/tx/:txID/edit",
      meta: { auth: () => Transaction.canBeCreatedBy(store.state.main.user) },
      component: () => import("../../../dialogs/employee/TxEdit"),
    },
    {
      name: "tx-view",
      path: "/tx/:txID/view",
      meta: { auth: () => Transaction.canBeViewedBy(store.state.main.user) },
      component: () => import("../../../dialogs/employee/TxView"),
    },
  ],
};
